let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lxHYR")).then(() => parcelRequire('6vn2F'));